/** parseObservationFilters produce a filter object (see example) populated
 * from the given URLSearchParams object. */
export const parseObservationFilters = (params /* URLSearchParams */) => ({
  // Filters
  from: params.get("from"), // ISO date/time string, or key for `dateTimeProducer` fn
  to: params.get("to"), // ISO date/time string, or key for `dateTimeProducer` fn
  astrosite_id: params.get("astrosite_id"),
  id_cnts: params.get("id_cnts"), // The id contains any of the provided text
  object_id: params.get("object_id"),
  object_name: params.get("object_name"),
  object_type: params.get("object_type"),
  object_count: params.get("object_count"), // Supports: 3-5, >3, <10
  task_type: params.get("task_type"),
  pipeline_id: params.get("pipeline_id"),
  tag_id: params.get("tag_id"),
  solve_status: params.get("solve_status"),
  archived: params.get("archived"),
  include_archived: params.get("include_archived"),
  observation_ids: params.get("observation_ids"),
  sort_order: params.get("sort_order") || "DESC", // The sort order
  sort_by: params.get("sort_by") || "timestamp", // The column to sort by
})
